import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Apply persisted theme before first paint to avoid flash
try {
  const stored = JSON.parse(localStorage.getItem('tonys-pwa-theme') || '{}')
  if (stored?.state?.isDark === false) {
    document.documentElement.classList.add('pwa-light')
  }
} catch (_) {}

// ── Service Worker Registration ──────────────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[PWA] Service worker registered:', registration.scope)

        // Listen for updates — when a new SW is waiting, prompt user to refresh
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return

          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // A new version is available — dispatch event for App to handle
              window.dispatchEvent(new CustomEvent('pwa-update-available', {
                detail: { registration }
              }))
            }
          })
        })
      })
      .catch((err) => {
        console.warn('[PWA] Service worker registration failed:', err)
      })

    // When SW controller changes (new SW took over), reload to get fresh assets
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true
        window.location.reload()
      }
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
